import 'bui/sw/client/on-app-updated'

window.addEventListener('load', function() {
    if( navigator.serviceWorker && !IS_LOCAL )
        navigator.serviceWorker.register('/sw.js')
});